import React from "react";
import { Checkbox, FormControlLabel } from "@mui/material";

const LabelWrapper = ({ condition, wrapper, children }) => (condition ? wrapper(children) : children);

export default function CustomCheckbox(props) {
    const {
        label,
        labelPlacement,
        className,
        disabled,
        name,
        onChange,
        onBlur,
        sx,
        inputRef,
        checked,
        icon,
        checkedIcon,
        color,
    } = props;
    return (
        <LabelWrapper
            condition={label}
            wrapper={(children) => (
                <FormControlLabel
                    label={label}
                    sx={{
                        ...sx,
                        "& .MuiCheckbox-root": {
                            padding: "0px",
                        },
                    }}
                    labelPlacement={labelPlacement}
                    control={children}
                />
            )}
        >
            <Checkbox
                name={name}
                className={className}
                icon={icon}
                checkedIcon={checkedIcon}
                color={color}
                {...typeof checked === "boolean" && { checked }}
                {...checked === 1 && { checked: true }}
                {...checked === -1 && { checked: false }}
                disabled={disabled}
                inputRef={inputRef}
                onChange={onChange}
                onBlur={onBlur}
            />
        </LabelWrapper>
    );
}
